import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { CheckoutProvider } from 'lib/shared'
import { Billing } from './scenes/Billing'
import { Shipping } from './scenes/Shipping'
import { Success } from './scenes/Success'

export const Checkout = () => {
  return (
    <CheckoutProvider>
      <Switch>
        <Route
          exact
          path='/checkout/shipping'
          component={Shipping}
        />

        <Route
          exact
          path='/checkout/billing'
          component={Billing}
        />

        <Route
          exact
          path='/checkout/success'
          component={Success}
        />

        <Redirect
          to='/checkout/shipping'
        />
      </Switch>
    </CheckoutProvider>
  )
}
